import { useState, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const useFetchData = (apiFn) => {
  const { getAccessTokenSilently } = useAuth0();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const stableApiFn = useCallback(apiFn, [apiFn]);

  const fetchData = useCallback(
    async (...args) => {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const res = await stableApiFn(token, ...args);
        setData(res);
      } catch (error) {
        console.error("Fetch failed:", error);
      } finally {
        setLoading(false);
      }
    },
    [stableApiFn, getAccessTokenSilently]
  );

  const fetchWithDelay = useCallback(
    (...args) => {
      const timer = setTimeout(() => {
        fetchData(...args);
      }, 100);
      return () => clearTimeout(timer);
    },
    [fetchData]
  );

  return {
    data,
    loading,
    fetchData,
    fetchWithDelay,
  };
};

export const useApiAction = (apiFn) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const execute = useCallback(
    async (...args) => {
      setLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const response = await apiFn(token, ...args);
        setData(response);
        return response;
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [apiFn, getAccessTokenSilently]
  );

  return { execute, loading, data, setData };
};
